import { ComboboxItem } from '@mantine/core';

import { EnrichedAppointmentType } from '@/models/appointment/EnrichedPractitionerData.ts';
import { AppointmentType } from '@/models/doc-cirrus/DCScheduleTypeMapping.ts';

export interface AppointmentFormOptions {
    all_practices: ComboboxItem[];
    practitioners: {
        id: string;
        name: string;
        calendars: ComboboxItem[];
    }[];
    appointment_types: AppointmentTypeFormOption[];
    unmapped_schedule_types: AppointmentTypeFormOption[];
}

export interface AppointmentTypeFormOption extends ComboboxItem {
    is_mapped?: boolean;
    is_offered?: boolean;
    is_notification_enabled?: boolean;
    default_duration: EnrichedAppointmentType['duration'];
    appointment_type: AppointmentType;
}

export interface CalendarFormOption extends ComboboxItem {
    offers_selected_appointment?: boolean | undefined; // TODO: to enrich so when we select the appointment we know how to re render
}

export enum AppointmentFormStep {
    PRACTICE = 'PRACTICE',
    INSURANCE = 'INSURANCE',
    PRACTITIONER = 'PRACTITIONER',
    APPOINTMENT_TYPE = 'APPOINTMENT_TYPE',
    TIMESLOT = 'TIMESLOT',
    ADDITIONAL_INFO = 'ADDITIONAL_INFO',
}
